import { render, staticRenderFns } from "./AddressChooser.vue?vue&type=template&id=98d7b122&scoped=true&"
import script from "./AddressChooser.vue?vue&type=script&lang=js&"
export * from "./AddressChooser.vue?vue&type=script&lang=js&"
import style0 from "./AddressChooser.vue?vue&type=style&index=0&id=98d7b122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d7b122",
  null
  
)

export default component.exports